import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_PoolPrizeSplit = _resolveComponent("PoolPrizeSplit")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorySplitRef, (category, i) => {
    return (_openBlock(), _createBlock(_component_a_row, {
      gutter: 10,
      key: category.categoryID + i
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(category.name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      class: "custom-input-style",
                      value: category.number,
                      "onUpdate:value": ($event: any) => ((category.number) = $event),
                      placeholder: "qty",
                      onBlur: _ctx.changed
                    }, null, 8, ["value", "onUpdate:value", "onBlur"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_a_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_card, { style: {"width":"100%"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, "Prizes for " + _toDisplayString(category.name) + " VAT", 1),
                    _hoisted_1,
                    _createVNode(_component_a_tooltip, {
                      placement: "right",
                      title: "Select the prize categories and quantities you would like to make available during each interval at each location(if GPS)"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          class: "custom-input-style",
                          mode: "multiple",
                          value: _ctx.prizeSplitRef[i],
                          placeholder: "Please select",
                          style: {"width":"100%"},
                          onChange: ($event: any) => (_ctx.handlePrizeChange($event, category))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prizesList, (prize) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: prize.id,
                                value: 
									`${prize.id}_${prize.name}_${prize.campaignID}`
								
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(prize.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["value", "onChange"])
                      ]),
                      _: 2
                    }, 1024),
                    (
							category.prizeSplit &&
								category.prizeSplit.length > 0
						)
                      ? (_openBlock(), _createBlock(_component_PoolPrizeSplit, {
                          key: 0,
                          categoryNumber: category.number,
                          prizeSplit: category.prizeSplit,
                          onChanged: _ctx.savePrizeSplit
                        }, null, 8, ["categoryNumber", "prizeSplit", "onChanged"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 2
    }, 1024))
  }), 128))
}